var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-9"},[_c('p',[_vm._v("Die aufgerufene Seite konnte leider nicht gefunden werden")])])])
}]

export { render, staticRenderFns }